/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'

import { ErrorBoundary } from '~/components'
import { styles } from './styles'
import { AnalyticsStore } from '~/stores'

interface ScreenProps {
  id: string
  title: string
  description: string
  url: string
  keywords?: string[]
  image?: string
  favicon?: string
}

export const Screen: FunctionComponent<ScreenProps> = ({
  id,
  title,
  description,
  keywords = [],
  url,
  image,
  favicon = require('~/assets/favicon.png'),
  children,
}) =>
  useMemo(() => {
    AnalyticsStore.navigation(url.replace(location.origin, ''))

    return (
      <ErrorBoundary id={title} metadata={{ url }}>
        <Helmet>
          <title>{`${title}  -  PartScout`}</title>

          <meta name="description" content={description} />
          <meta name="keywords" content={keywords.join(',')} />

          <meta property="og:title" content={`${title}  -  PartScout`} />
          <meta property="og:site_name" content="PartScout" />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={image || favicon} />
          <meta property="og:url" content={url} />

          <meta name="twitter:card" content="summary" />

          <link rel="shortcut icon" type="image/png" href={image || favicon} />
        </Helmet>

        <main css={styles.children}>{children}</main>
      </ErrorBoundary>
    )
  }, [title, url, children])
